import { isTextSelected, onDelegatedClick, formatDate, getTodayYmd, dmyToYmd, ymdFormat } from '../functions.js';

export default class EasepickElement extends HTMLElement {

    #picker       = null;
    #inputElement = null;
    #slots        = null;
    #currentMonth = null;

    connectedCallback() {
        let stylesheets = [
            'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
            window.APP_URL + 'css/calendar.css',
            // window.APP_URL + 'css/calendar-' + element.dataset.pack + '.css',
        ];

        this.#inputElement = this.querySelector('input[name=date]');

        if (this.dataset.slots) {
            this.#slots = JSON.parse(this.dataset.slots);
        }

        // this.style.opacity = 0;
        this.#picker = new easepick.create({
            element: this.#inputElement,
            css: stylesheets,
            zIndex: 10,
            format: 'YYYY-MM-DD',
            readonly: false,
            // lang: window.EASEPICK_LANG,
            locale: {
                previousMonth: `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.3335 8.4841L11.2647 0.5L12.663 1.90854L6.119 8.49708L12.6668 15.0908L11.2686 16.5L3.33736 8.51395L3.35089 8.50097L3.3335 8.4841Z" fill="#0C121C"/>
                </svg>`,
                nextMonth: `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6665 8.5159L4.73526 16.5L3.33704 15.0915L9.881 8.50292L3.33317 1.90919L4.7314 0.5L12.6626 8.48605L12.6491 8.49903L12.6665 8.5159Z" fill="#0C121C"/>
                </svg>`,
            },
            inline: true,
            LockPlugin: { // https://easepick.com/packages/lock-plugin.html
                filter: date => {
                    // date = formatDate(date);
                    date = ymdFormat(date);
                    return !this.#isDateIncluded(date);
                }
            },
            plugins: ['LockPlugin']
        });

        

        if (this.#slots) {
            this.#goToSoonest();
        }
        this.#bindEvents();
        this.#refreshButtons();
        
    }

    #bindEvents() {
        this.#picker.on('select', event => {
            this.#triggerDateChange();
        });

        this.#picker.on('render', event => {
            this.#currentMonth = event.detail.date.getMonth() + 1;
        });

        // this.#picker.on('view', (evt) => {
        //     const { view, date, target } = evt.detail;

        //     if (view === 'CalendarDay') {
        //         if (target.classList.contains('locked')) {
        //             return;
        //         }
        //         const d = date ? date.format('DD/MM/YYYY') : null;

        //         if (!isDateAvailable(d)) {
        //             target.classList.add('unavailable');
        //         } else {
        //             target.classList.remove('unavailable');
        //         }
        //     }
        // });

        this.querySelector('.js-today').addEventListener('click', (event) => {
            this.#goToToday();
            event.stopPropagation();
            event.preventDefault();
        });

        this.querySelector('.js-soonest').addEventListener('click', (event) => {
            this.#goToSoonest();
            event.stopPropagation();
            event.preventDefault();
        });
        

        // Capturamos evento con capture
        onDelegatedClick(this.querySelector('.easepick-wrapper').shadowRoot.firstChild, '.previous-button', (event) => {

            let targetMonth = this.#currentMonth - 1;

            if (!this.#isMonthAvailable(targetMonth)) {
                event.stopPropagation();
                event.preventDefault();
            }
            
        }, true);

        onDelegatedClick(this.querySelector('.easepick-wrapper').shadowRoot.firstChild, '.next-button', (event) => {

            let targetMonth = this.#currentMonth + 1;

            if (!this.#isMonthAvailable(targetMonth)) {
                event.stopPropagation();
                event.preventDefault();
            }
            
        }, true);

    }

    #goToToday() {
        let now = (new Date);
        this.#picker.setDate(now);
        this.#picker.gotoDate(now);
        this.#triggerDateChange();
    }

    #triggerDateChange() {
        let customEvent = new CustomEvent('datechange', { 
            detail: this.#inputElement.value, 
            bubbles: true
        });
        this.dispatchEvent(customEvent);
    }

    #isDateIncluded(date) {
        if (!this.#slots) {
            return false;
        }

        let slot = this.#slots.find(slot => {
            return slot.slot_date === date;
        });

        return !!slot;
        
    }

    setSlots(slots) {
        this.#slots = slots;
        this.#picker.renderAll();
        this.#goToSoonest();
        this.#refreshButtons();
    }

    #getDates() {
        return this.#slots.map(slot => slot.slot_date);
    }

    #goToSoonest() {

        let todayYmd = getTodayYmd();

        let gotoDate = null;

        let dates = this.#getDates();

        for (let i = 0; i < dates.length; i++) {
            if (dates[i] >= todayYmd) {
                gotoDate = dates[i];
                break;
            }
        }

        if (gotoDate === null && dates[dates.length - 1]) {
            gotoDate = dates[dates.length - 1];
        }

        this.#picker.setDate(gotoDate);
        this.#picker.gotoDate(gotoDate);
        this.#triggerDateChange();
    }

    #refreshButtons() {
        this.querySelector('.js-today').style.display = this.#isTodayAvailable() ? 'inline' : 'none';
        this.querySelector('.js-soonest').style.display = 'inline';
    }

    #isTodayAvailable() {
        let today = getTodayYmd();
        return this.#isDateIncluded(today);
    }

    #isMonthAvailable(month) {
        let dates = this.#getDates();

        for (let i = 0; i < dates.length; i++) {

            let parts = dates[i].split('-');
            let _month = parseInt(parts[1]);

            if (month === _month) {
                return true;
            }
        }
        
        return false;
    }



}
window.customElements.define('easepick-element', EasepickElement);

